import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {useEffect} from "react";


export default function CustomizedDialogs({html}) {
    const [open, setOpen] = React.useState(true);

    useEffect(()=>{
        setOpen(true)
    }, [html])

    return (
        <Dialog onClose={() => setOpen(false)} open={open}>
            <DialogTitle sx={{m: 0, p: 2}}>Работа над ошибками</DialogTitle>
            <IconButton title={"Закрыть"} onClick={() => setOpen(false)} sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
            })}><CloseIcon/></IconButton>
            <DialogContent dividers dangerouslySetInnerHTML={{__html: html}}/>
            <DialogActions>
                <Button id={"closeDialog"} autoFocus onClick={() => setOpen(false)}>Закрыть</Button>
            </DialogActions>
        </Dialog>
    );
}
